<template>
  <div
    :class="[cls, loading == 1 ? 'visible' : '']"
    :style="style"
    ref="target"
  >
    <slot />
  </div>
</template>

<script setup>
import { loadImage } from "~/helpers/file";
import { useElementVisibility } from "@vueuse/core";
import { useTemplateRef } from "vue";
const target = useTemplateRef("target");
const isVisible = useElementVisibility(target);

const props = defineProps(["src", "class"]);
const cls = props.class || "bg";
const style = ref({});
const loading = ref(0);
const src = props.src || "/static/image/video_bg3.jpg";

watch(isVisible, async (v) => {
  if (!loading.value && v) {
    loading.value = await loadImage(src);
    if (loading.value == 1) style.value = { backgroundImage: `url(${src})` };
  }
});
</script>
